module.exports = __webpack_public_path__ + "static/img/6.f65f6bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/zh/6.png
// module id = pC6f
// module chunks = 0